import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import Sprite from '../../../Prototype/Sprite';
import { Point } from 'pixi.js';
import { createRotationTween, getTweenProps } from '../AnimationTweenHelper';
import { Easing } from '@tweenjs/tween.js';
import { AwaitIterators } from '../AnimationHelper';
import Text from '../../../Prototype/Text';
import Game from '../../../Game';

type RewardBoostersEffectParams = (
  { texture: string } |
  { text: string; }
);

export class RewardBoostersEffect extends AnimationClip<RewardBoostersEffectParams> {
    public *execute(
        gameObject: GameObject,
        meta: RewardBoostersEffectParams
    ): IterableIterator<number> {
        const icon = (meta as { texture: string }).texture
            ? GameObject.Instantiate(Sprite, {
                  texture: (meta as { texture: string }).texture,
                  anchor: new Point(0.5, 0.5),
              })
            : GameObject.Instantiate(Text, {
                  text: (meta as { text: string }).text,
                  style: Game.style.getStyle('Shop.freeLevel'),
                  anchor: new Point(0.5, 0.5),
              });
        const flair = GameObject.Instantiate(Sprite, {
            texture: 'flair',
            anchor: new Point(0.5, 0.5),
        });
        const halo = GameObject.Instantiate(Sprite, {
            texture: 'yeallow_halo',
            anchor: new Point(0.5, 0.5),
        });

        const rotationTween = createRotationTween({
            ...getTweenProps(flair, this, 3),
            duration: 1500,
            easing: Easing.Linear.None,
        });

        this.gameObject.addChild(flair);
        this.gameObject.addChild(halo);
        this.gameObject.addChild(icon);

        return yield* AwaitIterators([this.startTween(rotationTween)]);
    }
}
